import React from 'react';
import BookAppointment from '../components/BookAppointment/BookAppointment';

const AppointmentPage = () => {
    console.log("AppointmentPage Rendered");
    return (

        <BookAppointment />
    )
}

export default AppointmentPage;